import { css, Theme } from '@emotion/react'
import { alpha, chipClasses } from '@mui/material'

export const modal = css`
  .container {
    display: block;
    width: 800px;
    max-height: calc(100% - 20px);
    max-width: calc(100% - 20px);
    overflow-y: auto;
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.colors.typographyTwo};
  font-weight: 700;
  line-height: 20px;
`

export const list = css`
  margin: 0;
  padding: 0;
  width: 100%;

  list-style-type: none;
`

export const listItem = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: ${theme.spacing(2)};
  padding: ${theme.spacing(1.75)};
  border-radius: 20px;
  border: 1px solid ${theme.colors.backgroundOne};
`

export const stack = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.25)};
`

export const chip = (theme: Theme) => css`
  max-width: 230px;
  padding: ${theme.spacing(0.75, 1.25)};
  height: 30px;

  color: ${theme.colors.java};
  font-weight: 700;
  font-size: 14px;

  background-color: ${alpha(theme.colors.java, 0.1)};

  .${chipClasses.label} {
    padding: 0;

    line-height: 17px;
  }
`

export const editButton = (theme: Theme) => css`
  width: 48px;
  height: 48px;
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 14px;
`

export const divider = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const addLink = css`
  text-decoration: none;
`

export const addButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const noSectionsTitle = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`
